import { createApi } from '@reduxjs/toolkit/query/react';

import {
  DictionariesEndpoints as Endpoints,
  type GetClientLanguagesRequest,
  type GetClientLanguagesResponse,
  type GetCountriesRequest,
  type GetCountriesResponse,
  type GetMedicalDictionaryRequest,
  type GetMedicalDictionaryResponse,
  type GetUsedCitiesRequest,
  type GetUsedCitiesResponse,
  type GetUsedCountriesRequest,
  type GetUsedCountriesResponse,
} from '@app/api/Dictionaries/types';
import { createApiBaseQuery, Methods } from '@app/api/shared';
import { DICTIONARIES_RESOURCE } from '@app/constants';

export const dictionariesApi = createApi({
  reducerPath: 'dictionariesApi',
  baseQuery: createApiBaseQuery(DICTIONARIES_RESOURCE),
  endpoints: ({ query }) => ({
    [Endpoints.GetCountries]: query<GetCountriesResponse, GetCountriesRequest>({
      query: (params) => ({
        url: Endpoints.GetCountries,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.GetUsedCountries]: query<
      GetUsedCountriesResponse,
      GetUsedCountriesRequest
    >({
      query: (params) => ({
        url: Endpoints.GetUsedCountries,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.GetUsedCities]: query<
      GetUsedCitiesResponse,
      GetUsedCitiesRequest
    >({
      query: (params) => ({
        url: Endpoints.GetUsedCities,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.GetClientLanguages]: query<
      GetClientLanguagesResponse,
      GetClientLanguagesRequest
    >({
      query: (params) => ({
        url: Endpoints.GetClientLanguages,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.GetMedicalDictionary]: query<
      GetMedicalDictionaryResponse,
      GetMedicalDictionaryRequest
    >({
      query: ({ type, ...params }) => ({
        url: `${Endpoints.GetMedicalDictionary}/${type}`,
        method: Methods.GET,
        params,
      }),
    }),
  }),
});

export const {
  useGetCountriesQuery,
  useLazyGetCountriesQuery,
  useGetUsedCountriesQuery,
  useLazyGetUsedCountriesQuery,
  useGetUsedCitiesQuery,
  useLazyGetUsedCitiesQuery,
  useGetClientLanguagesQuery,
  useLazyGetClientLanguagesQuery,
  useGetMedicalDictionaryQuery,
  useLazyGetMedicalDictionaryQuery,
} = dictionariesApi;
